import axios from 'axios';
let jsonpAdapter = require('axios-jsonp');
const baseUrl = 'https://sjbkdy.fusjb.com/api/';

const Request = function( opts ) {
    let params = formatParams(opts.params ? opts.params : {});
    opts.url = opts.url + (params.length ? '?' + params : '');
    axios({
        method: opts.method ? opts.method : 'get',
        url: baseUrl + opts.url,
        adapter: jsonpAdapter,
        data: opts.params ? opts.params : {},
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    }).then(res => {
        if(opts.success) {
            opts.success(res.data);
        }
    }, res => {
        if(opts.fail) {
            opts.fail();
        }
    }).catch(err => {
        console.log("error:",err);
    });
}
function formatParams( params ) {
    let keys = Object.keys( params );
    let paramsArr = [];
    for( var key in keys ) {
        paramsArr.push(`${keys[key]}=${params[keys[key]]}`)
    }
    return paramsArr.join( '&' );
}
export default Request;